import { useRef, useState, useEffect } from "react";

/**
 * Shared IntersectionObserver hook.
 * Fires once when the element enters the viewport.
 */
const useInView = (options = {}) => {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsInView(true);
      },
      { threshold: 0.1, ...options }
    );
    observer.observe(el);
    return () => observer.disconnect();
    // options is intentionally excluded — callers pass object literals;
    // adding it would cause infinite re-runs.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [ref, isInView];
};

export default useInView;
